const { Enums } = require("../enums");
const { ModelValidationException } = require("../exceptions/modelValidationException");
const { isObjectFalsy } = require("../utils/objectUtils");

/**
 * @typedef {import("../types.d")}
 */

/**
 * Validates the notification data.
 * @param {Notification} notificationData - The notification data to validate.
 * @param {boolean} throwError - Should this throw an error if validation fails?
 * @throws {ModelValidationException} If the notification data is invalid.
 */
function validateNotification(notificationData, throwError = true) {
    const validationErrors = [];

    if (notificationData.userId && notificationData.channelId) {
        // t("Cannot set both UserId and ChannelId")
        validationErrors.push({ fields: ["userId", "channelId"], message: "Cannot set both UserId and ChannelId" });
    }
    if (!notificationData.userId && !notificationData.channelId) {
        validationErrors.push({
            fields: ["userId", "channelId"],
            // t("Either UserId or ChannelId must be set")
            message: "Either UserId or ChannelId must be set",
        });
    }
    if (!notificationData.title) {
        // t("Title must be set")
        validationErrors.push({ fields: ["title"], message: "Title must be set" });
    }
    if (!notificationData.snippet && !notificationData.content && !notificationData.url) {
        validationErrors.push({
            fields: ["snippet", "content", "url"],
            // t("At least one of Snippet, Content, or URL must be set")
            message: "At least one of Snippet, Content, or URL must be set",
        });
    }
    if (notificationData.availableTo && notificationData.availableTo < notificationData.availableFrom) {
        validationErrors.push({
            fields: ["availableTo", "availableFrom"],
            // t("AvailableTo must be after AvailableFrom")
            message: "AvailableTo must be after AvailableFrom",
        });
    }
    if (notificationData.availableTo && notificationData.availableTo < notificationData.timestamp) {
        validationErrors.push({
            fields: ["availableTo", "timestamp"],
            // t("AvailableTo must be after Timestamp")
            message: "AvailableTo must be after Timestamp",
        });
    }
    if (notificationData.availableFrom < notificationData.timestamp) {
        validationErrors.push({
            // t("AvailableFrom must be after Timestamp")
            fields: ["availableFrom", "timestamp"],
            message: "AvailableFrom must be after Timestamp",
        });
    }
    if (isObjectFalsy(notificationData.from)) {
        // t("From must be set")
        validationErrors.push({ fields: ["from"], message: "From must be set" });
    } else if (notificationData.from.userId && notificationData.from.name) {
        // t("From must have either UserId or Name, not both")
        validationErrors.push({ fields: ["from"], message: "From must have either UserId or Name, not both" });
    }
    if (Enums.NotificationSource[notificationData.source] === undefined) {
        // t("Invalid source")
        validationErrors.push({ fields: ["source"], message: "Invalid source" });
    }
    if (validationErrors.length > 0) {
        if (!throwError) {
            return validationErrors;
        }
        // t("Invalid notification data")
        throw new ModelValidationException("Invalid notification data", validationErrors);
    }
    return [];
}

module.exports = { validateNotification };
